import { Group, Path, Segment, Shape } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER } from "../../constants";

export default class Glasses extends Group {
  constructor() {
    const glassLeft = new Shape.Circle({
      center: [CANVAS_CENTER - 7, 39],
      radius: 5,
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });
    const glassRight = new Shape.Circle({
      center: [CANVAS_CENTER + 7, 39],
      radius: 5,
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });
    const frameBridge = new Path({
      segments: [
        new Segment({
          point: [CANVAS_CENTER - 3, 37],
          handleOut: [2, -1],
        }),
        new Segment({
          point: [CANVAS_CENTER + 3, 37],
          handleIn: [-2, -1],
        }),
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });
    const frameLeft = new Path({
      segments: [
        [CANVAS_CENTER - 16, 35],
        [CANVAS_CENTER - 10, 35],
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });
    const frameRight = new Path({
      segments: [
        [CANVAS_CENTER + 16, 35],
        [CANVAS_CENTER + 10, 35],
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });

    super([glassLeft, glassRight, frameBridge, frameLeft, frameRight]);

    this.initialPositionY = this.position.y;
    this.position.y = this.initialPositionY + 2;
  }

  initialPositionY: number;

  animateIn = () =>
    new Promise((resolve) => {
      return this.tweenTo(
        { "position.y": this.initialPositionY - 1 },
        { duration: 300, easing: "easeInOutQuad" },
      ).then(() => {
        this.tweenTo(
          { "position.y": this.initialPositionY + 1 },
          { duration: 150, easing: "easeInOutQuad" },
        ).then(resolve);
      });
    });
}
